export const EXCEPTION_MESSAGE_TYPE_RESI = `Resi`
export const EXCEPTION_MESSAGE_TYPE_CONTAINER = `Container`
export const EXCEPTION_MESSAGE_TYPE_BULK = `Bulk`
export const EXCEPTION_MESSAGE_TYPE_MOVERS = `Movers`
export const EXCEPTION_PAGE_TYPE_DEFAULT = `default`
export const EXCEPTION_PAGE_TYPE_LOCAL = `local`
